export default "__VITE_ASSET__DagT5s7i__"